import { theme } from '@nobia/zeus-components/lib/styled'

const borderColor = '#E5E5E5'
export default {
  breadcrumbs: {
    fontSize: '13px',
    fontWeight: '300',
    default: {
      color: theme('colors.black'),
      colorHover: theme('colors.black'),
      colorMobile: theme('colors.black'),
      textDecoration: 'underline',
    },
    hasBackground: {
      color: theme('colors.black'),
      colorHover: 'currentColor',
    },
  },
  app: {
    width: '1420px',
    mobile: {
      width: '1420px',
      margin: '0 auto',
    },
    wideDesktop: {
      width: '1880px',
    },
  },
  grid: {
    container: '100%',
  },
  header: {
    title: {
      textTransform: 'none',
      letterSpacing: '0px',
    },
    mobile: {
      maxWidth: '100%',
    },
    layout: 'left',
    maxWidth: '837px',
  },
  collapse: {
    color: theme('colors.black'),
    fontWeight: '700',
    borderRadius: '25px',
    backgroundColor: theme('colors.white'),
    border: {
      color: borderColor,
    },
    label: {
      fontWeight: '300 !important',
    },
    title: {
      fontSize: '13px',
      transform: 'uppercase',
      letterSpacing: '0.8px',
    },
    clearFilter: {
      fontWeight: '300',
      fontFamily: 'Clan',
      fontSize: '13px',
    },
    productInfo: {
      borderColors: borderColor,
    },
  },
  categoryCard: {
    backgroundColor: '#F7EFE9',
    title: {
      fontSize: '16px',
      fontWeight: '700',
    },
    preamble: {
      fontSize: '13px',
    },
    paragraph: {
      fontSize: '13px',
      lineHeight: '20px',
    },
    borderRadius: '0',
  },
  categories: {
    price: {
      fontWeight: '300',
    },
  },
  filter: {
    borderRadius: '0 25px 25px 0',
  },
  dropdown: {
    color: theme('colors.black'),
    fontWeight: '400',
    lineHeight: '22px',
    borderColors: borderColor,
    borderRadius: '25px',
    backgroundColor: 'transparent',
    padding: '10px 16px',
    fontFamily: 'Clan',
    panel: {
      borderRadius: '0 0 25px 25px',
    },
    closed: {
      borderRadius: '25px 0 0 25px',
    },
    open: {
      borderRadius: '25px 0  0 0',
    },
  },
  productCard: {
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '22px',
    title: {
      transform: 'uppercase',
    },
    price: {
      fontSize: '18px!important',
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
    },
    preamble: {
      marginTop: '0',
      marginBottom: '0',
    },
  },
  paragraph: {
    fontSize: '16px',
  },
  typography: {
    pageTitle: {
      fontSize: '32px',
      lineHeight: '38px',
      mobile: {
        fontSize: '22px',
        lineHeight: '28px',
      },
    },
  },
  featureList: {
    title: {
      textTransform: 'none',
      letterSpacing: 'normal',
      fontWeight: '400 !important',
      fontSize: '14px',
    },
    data: {
      fontSize: '14px',
      fontWeight: '400',
    },
  },
  background: {
    backgroundColor: '#F7EFE9',
  },
  sidePanel: {
    buttons: {
      fontWeight: '700',
      borderRadius: '25px',
    },
    clearButton: {
      backgroundColor: 'transparent',
      borderColor: theme('colors.black'),
      color: theme('colors.black'),
    },
    viewButton: {
      backgroundColor: theme('colors.black'),
    },
  },
  paging: {
    backgroundColor: theme('colors.black'),
    lineHeight: 0.8,
  },
  swipe: {
    button: {
      height: '44px',
      width: '54px',
    },
  },
}
